/**
 * Created by emanuele on 31/01/2017.
 */
import React from 'react';
import { Progress } from 'semantic-ui-react'

const AttivitaProgress = ({ percCompletamento, title = '' }) => {

    if (percCompletamento < 80){
        return <Progress percent={percCompletamento}  progress='percent' error title={title}/>
    }
    else if (percCompletamento >= 80 && percCompletamento < 99){
        return <Progress percent={percCompletamento}  progress='percent' warning  title={title} />
    }
    else {
        return <Progress percent={percCompletamento}  progress='percent' success  title={title}/>
    }
}

export default AttivitaProgress;


/** WEBPACK FOOTER **
 ** ./src/components/attivita/AttivitaProgress.jsx
 **/